import { useEffect } from 'react';

export default function SEO({ title, description, jsonLd, canonical, image }) {
  useEffect(() => {
    if (title) document.title = title;
    setMeta('description', description || '');
    setMeta('og:title', title || '', true);
    setMeta('og:description', description || '', true);
    setMeta('og:type', 'website', true);
    if (image) setMeta('og:image', image, true);
    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', canonical);
    }
    // JSON-LD
    let scriptEl = document.getElementById('seo-jsonld');
    if (jsonLd) {
      if (!scriptEl) {
        scriptEl = document.createElement('script');
        scriptEl.id = 'seo-jsonld';
        scriptEl.type = 'application/ld+json';
        document.head.appendChild(scriptEl);
      }
      scriptEl.textContent = JSON.stringify(jsonLd);
    } else if (scriptEl) {
      scriptEl.remove();
    }
  }, [title, description, jsonLd, canonical, image]);
  return null;
}

function setMeta(name, value, isProperty = false) {
  if (!value) return;
  const attr = isProperty ? 'property' : 'name';
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', value);
}
